import { render, staticRenderFns } from "./administrador.vue?vue&type=template&id=a07b0da6&scoped=true"
import script from "./administrador.vue?vue&type=script&lang=js"
export * from "./administrador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07b0da6",
  null
  
)

export default component.exports